<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
      <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/subscriptionModule">Subscription Module</a></li>
          <li class="breadcrumb-item" disabled><a routerLink="/corporate/subscription-feature-list">Subscription Feature</a></li>
          <li class="breadcrumb-item active" aria-current="page">Add Subscription Feature</li>
      </ol>
  </nav>
</div>

<div class="container">
  <div class="row">
    <div class="col-md-8">
      <form class="form-horizontal" [formGroup]="addFeatureForm">
        <div class="card">
          <div class="card-body">
            <div class="form-group" *ngIf="customer_id===0">
              <label for="exampleForm2">Company Name <span class="required">*</span></label>
              <select formControlName="selectedCompany" class="form-control formstyle ssss"
                (change)="loadSubscriptions()"
                [ngClass]="{ 'is-invalid': submitted && f.selectedCompany.errors }">
                <option value="">Select Company Name</option>
                <ng-container *ngFor="let Obj of getCompanyobj">
                  <option *ngIf="Obj.dbstatus == true" value={{Obj.customer_id}}>
                    {{Obj.customer_company_name}}
                  </option>
                </ng-container>
              </select>
              <div *ngIf="submitted && f.selectedCompany.errors" class="invalid-feedback">
                <div *ngIf="f.selectedCompany.errors.required">Company Name is required</div>
              </div>
            </div>

            <input *ngIf="customer_id!=0" type="hidden" formControlName="selectedCompany">
            <div class="form-group">
              <label for="name">Feature Name <span class="required">*</span></label>
              <input type="text" class="form-control" name="feature_name" formControlName="feature_name"
                [ngClass]="{ 'is-invalid': submitted && f.feature_name.errors }" maxlength="100">
              <div *ngIf="submitted && f.feature_name.errors" class="invalid-feedback">
                <div *ngIf="f.feature_name.errors.required">Feature Name is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="name">Slug Title</label>
              <input type="text" class="form-control" name="feature_slug" formControlName="feature_slug" maxlength="100">
            </div>
            <div class="form-group">
              <label for="exampleForm2">Feature Type <span class="required">*</span></label>
              <select formControlName="feature_type" class="form-control formstyle ssss"
                 [ngClass]="{ 'is-invalid': submitted && f.feature_type.errors }">
                <option value="boolean">boolean</option>
                <option value="character">character</option>
                <option value="number">number</option>
              </select>
              <div *ngIf="submitted && f.feature_type.errors" class="invalid-feedback">
                <div *ngIf="f.feature_type.errors.required">Feature type is required</div>
              </div>
            </div>
            <div class="form-group">
              <label for="feature_desc">Description</label>
              <textarea class="form-control text-area" rows="4" name="feature_desc" formControlName="feature_desc"
                placeholder="Enter description"></textarea>
            </div>
            <div class="form-group">
              <label for="orderno">Order Number</label>
              <input type="number" class="form-control" name="order_no" formControlName="order_no">
            </div>
            <div class="form-group">
              <label>Assign Subscription</label>
              <div *ngIf="subsObj.length === 0" class="mt-1">No subscription available. Select a company first.</div>
              <table class="mt-1 bdrStCustom" width="100%" cellpadding="0" cellspacing="0" *ngIf="subsObj.length > 0">
                <tr>
                  <th>Subscription</th>
                  <th width="90" style="text-align:center">Assign</th>
                  <th>Feature Value</th>
                </tr>
                <tr *ngFor="let item of subsObj">
                  <td>{{item.title}}</td>
                  <td align="center">
                    <label class="custmCheck">
                      <input type="checkbox" [checked]="isSubChecked(item.id)"
                        (change)="toggleSub(item.id, $event.target.checked)">
                      <span class="checkmark"></span>
                    </label>
                  </td>
                  <td>
                    <input type="text" class="form-control" [(ngModel)]="featureValues[item.id]"
                      [ngModelOptions]="{standalone: true}" [disabled]="!isSubChecked(item.id)"
                      placeholder="true / 2GB / Unlimited">
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="card-footer">
            <div class="text-center">
              <button class="btn btn-round btn-margo-action" (click)="addNewFeatureData()">Save
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
